import { render, staticRenderFns } from "./Loja.vue?vue&type=template&id=486e6a39&scoped=true&"
import script from "./Loja.vue?vue&type=script&lang=ts&"
export * from "./Loja.vue?vue&type=script&lang=ts&"
import style0 from "./Loja.vue?vue&type=style&index=0&id=486e6a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486e6a39",
  null
  
)

export default component.exports